import React from 'react';
import Link from 'next/link';
import ThumbnailImage from './thumbnail';
import Icon from './icon/Icon';

import { H3, Label } from './text';
import { Divider } from './divider';
import { IFeaturedImage } from '../models/featured-image';

interface IProps {
	title: string;
	coverImage?: IFeaturedImage;
	slug: string;
	categoryName?: string;
}

export default function FeaturedHeroPost({
	title,
	coverImage,
	slug,
	categoryName,
}: IProps) {
	return (
		<section>
			<Link href={`/nieuws/${slug}`}>
				<div className="relative w-full rounded-sm">
					{coverImage && (
						<ThumbnailImage
							title={title}
							coverImage={coverImage}
							classNames="block aspect-video object-cover rounded-sm"
						/>
					)}
					<div className="absolute bottom-0 left-0 p-8 w-full h-full flex flex-col justify-end">
						{categoryName && (
							<div className="inline-flex flex-col w-auto">
								<Label className="text-white lg:text-xl">
									{categoryName}
								</Label>
								<Divider />
							</div>
						)}
						{title && <H3 className="mb-6 text-white">{title}</H3>}
						<div className="flex items-center">
							<span className="inline-block mr-3 text-red-500 hover:text-red-700 font-inter font-semibold uppercase tracking-widest text-base lg:text-lg hover:underline">
								Naar het artikel
							</span>
							{/* Todo DEVP-140: Add hover states to Icon */}
							<Icon
								icon={'arrow-right'}
								color="#E2013D"
								size={18}
							/>
						</div>
					</div>
				</div>
			</Link>
		</section>
	);
}
